import { localize } from '../compat/core';

const resx = localize("App");
const localizeResx = text => {
  if(text instanceof Array){
    for (let index = 0; index < text.length; index++) {
      text[index] = localizeInternal(text[index]);
    }

    return text;
  }

  return localizeInternal(text);
};


const localizeInternal = text => {
  return resx.App[text.replace(/…|\s/g, '')] || `[${text}]`;
}

export default localizeResx;